import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-square-button',
	templateUrl: './square-button.component.html',
	styleUrls: ['./square-button.component.scss'],
})
export class SquareButtonComponent implements OnInit {
	@Input() theme = '';
	@Input() value = '';
	@Input() disabled = false;
	@Input() type = '';
	@Input() tooltip = '';
	@Input() loading = false;
	@Input() progressDiameter = 30;

	constructor() {}

	ngOnInit(): void {}
}
